/* eslint-disable */
/**
 * 使用方法：
 *
 * ```
 * <Tooltip
 *   cursor={
 *     <CustomBarCursor
 *       fill="#abcdef"
 *     />
 *    }
 * />
 * ```
 */
export const CustomBarCursor = (props: any) => {
  const { fill, width, height, x, y } = props;
  if (x <= 0) return null;

  return (
    <svg>
      <rect x={x} y={y} width={width} height={height} fill={fill} />
    </svg>
  );
};
